<!-- Begin Page Content -->
<div class="container-fluid">

    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 class="h3 mb-0 text-gray-800">Usuarios</h1>
        
        <a class="d-none d-sm-inline-block btn btn-sm btn-success shadow-sm" [routerLink]="['/usuarios-add', '']"><i
                class="fas fa-plus fa-sm text-white-50" ></i> Nuevo usuario</a>
    </div>
    <div class="card shadow mb-4 border-left-primary">
        <div class="card-header py-3">
            <h6 class="m-0 font-weight-bold text-primary">Todos los usuarios</h6>
        </div>
        <div class="card-body">
            <div class="table-responsive">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">Usuario</th>
                            <th scope="col">Nombre</th>
                            <th scope="col">Email</th>
                            <th scope="col">Teléfono</th>
                            <th scope="col">Último Acceso</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let usuario of listUsuarios">
                            <td>{{usuario.id}}</td>
                            <td>{{usuario.nombre}}</td>
                            <td>{{usuario.email}}</td>
                            <td>{{usuario.telefono}}</td>
                            <td>{{usuario.ultimoAcceso | date:'dd/MM/yyyy HH:mm' }}</td>
                            <td>
                                <i [routerLink]="['/usuarios-add', usuario.id]" class="fas fa-edit text-primary"></i>
                                <i (click)="eliminarUsuario(usuario.id)" class="fas fa-trash text-secondary"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>